// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentContainer_wrapper__iG98s"};